import React from 'react'
import {connect} from 'react-redux'

import api from '../../api.js'

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export default function withManagers(WrappedComponent) {
  class WithManagers extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        loading: true,
        managers: [],
      }
    }

    componentDidMount = async () => {
      await this.loadOfferManagersByUniverse(this.props.currentUniverseId)
    }

    componentDidUpdate = async (prevProps) => {
      if (!this.state.loading && this.props.currentUniverseId !== prevProps.currentUniverseId) {
        await this.loadOfferManagersByUniverse(this.props.currentUniverseId)
      }
    }

    loadOfferManagersByUniverse = async (universeId = null) => {
      if (null !== universeId) {
        this.setState({loading: true})
        const managers = (await api.users.getBusinessManagersByUniverse({
          universe: universeId
        })).data
        this.setState({
          managers,
          loading: false,
        })
      }
    }

    render() {
      return <WrappedComponent
        loading={this.props.loading || this.state.loading}
        managers={this.state.managers} {...this.props}
      />
    }
  }
  WithManagers.displayName = `WithManagers(${getDisplayName(WrappedComponent)})`

  return connect(
    (state) => ({
      currentUniverseId: state?.universe?.currentUniverse?.id ?? null,
    })
  )(WithManagers)
}
